import React from 'react';
import styles from '../irlObservations2026.module.css';
import { SuggestHeader, SuggestTabs, SuggestionEdit, stripHtmlText, suggestionCardKey } from './shared';

export default function IRL_AI_Review_Review_Suggestions_Followup({
    tab,
    tabs,
    onTab,
    onBack,
    items,
    onOpen,
    counts,
    reviewMeta,
    onAccept,
    onDismiss,
    busy,
}) {
    const [editingId, setEditingId] = React.useState(null);
    const [editText, setEditText] = React.useState('');
    return (
        <>
            <SuggestHeader onBack={onBack} meta={reviewMeta} />
            <SuggestTabs tabs={tabs} tab={tab} onTab={onTab} counts={counts} />
            <div className={styles.detailBody}>
                {items.map(item => {
                    const done = item.status === 'ACCEPTED' || item.status === 'DISMISSED';
                    const cardKey = suggestionCardKey(item);
                    const title = stripHtmlText(item.title);
                    const question = stripHtmlText(item.question);
                    const reason = stripHtmlText(item.reason);
                    const editing = editingId === cardKey;
                    return (
                        <div key={cardKey} className={styles.suggestCard}>
                            <div className={styles.suggestId}>Suggested follow-up · Parent: {item.parentId}</div>
                            <div className={styles.rowTitle}>{title}</div>
                            <p className={styles.responseBody}>Reason: {reason}</p>
                            {item.related && (
                                <div className={styles.relatedBanner}>
                                    <p>Related request found</p>
                                    <p>
                                        {item.related.id} – {stripHtmlText(item.related.title)}
                                    </p>
                                    <button type="button" className={styles.alertLink} onClick={() => onOpen?.(item.related.id)}>
                                        Open {item.related.id} →
                                    </button>
                                </div>
                            )}
                            {editing && (
                                <SuggestionEdit
                                    value={editText}
                                    onChange={setEditText}
                                    onSave={() => {
                                        onAccept?.(item, editText);
                                        setEditingId(null);
                                    }}
                                    onCancel={() => setEditingId(null)}
                                    disabled={busy || done}
                                />
                            )}
                            <div className={styles.actionRow}>
                                <button
                                    type="button"
                                    className={styles.primaryBtn}
                                    onClick={() => onAccept?.(item)}
                                    disabled={done || busy}>
                                    {item.status === 'ACCEPTED' ? 'Created' : 'Create request'}
                                </button>
                                {!editing && (
                                    <button
                                        type="button"
                                        className={styles.outlineBtn}
                                        onClick={() => {
                                            setEditingId(cardKey);
                                            setEditText(title || question);
                                        }}
                                        disabled={done || busy}>
                                        Edit & create
                                    </button>
                                )}
                                <button type="button" className={styles.mutedBtn} onClick={() => onDismiss?.(item)} disabled={done || busy}>
                                    {item.status === 'DISMISSED' ? 'Dismissed' : 'Reject'}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
